import { TypedDocumentNode, gql } from '@apollo/client';

export type UpdateAuthUserMutationVariables = {
  userId?: number;
  userData?: {
    first_name?: string;
    last_name?: string;
  };
};

export type UpdateAuthUserMutationResponse = {
  update_lager_auth_user_by_pk: {
    id: number;
    first_name: string;
    last_name: string;
  };
};

export const updateAuthUserMutation = gql`
  mutation updateAuthUserMutation(
    $userId: Int!
    $userData: lager_auth_user_set_input!
  ) {
    update_lager_auth_user_by_pk(pk_columns: { id: $userId }, _set: $userData) {
      id
      first_name
      last_name
    }
  }
` as TypedDocumentNode<
  UpdateAuthUserMutationResponse,
  UpdateAuthUserMutationVariables
>;
